export default "__VITE_ASSET__jgXCLGMJ__"